import {
    /** FETCH APPLICATION  */
    FETCH_GETMSS_FULFILLED,
    FETCH_GETMSS_REJECTED,
    FETCH_GETMSS_PENDING,
    RESET_GETMSS,
} from "../../actions/agreement/getMSS";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_GETMSS_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_GETMSS_FULFILLED:
            return {
                ...state,
                getMSS: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_GETMSS_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_GETMSS:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};